import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  DeleteProposalClientModel,
  SearchProposalClientModel,
} from '../../../models/proposal-client.model'
import { SearchContractClientModel, SendEmailContratoClienteModel } from '../../../models/contract-client.model'

@Injectable({
  providedIn: 'root',
})
export class ContractClientService {
  private baseUrl = environment.baseUrl
  private resource = 'ContratoCliente'

  constructor(private httpClient: HttpClient) {}

  public createContractClient(
    model: any,
    // model: CreateProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editContractClient(
    model: any,
    // model: EditProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteContractClient(
    model: DeleteProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public cancelContract(idContract: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/cancelar/${idContract}`,{}
    )
  }

  public approveContract(idContract: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/AprovarContrato/${idContract}`, {}
    )
  }

  public refuseContract(idContract: any): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/RecusarContrato/${idContract}`, {}
    )
  }

  // public cancelContract(idContract:any, model: any): Observable<ResponseRequestModel> {
  //   return this.httpClient.get<ResponseRequestModel>(
  //     `${this.baseUrl}${this.resource}/cancelar/${idContract}`,
  //   )
  // }

  public uploadContract(
    model: any,
    // model: CreateProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/upload`,
      model,
    )
  }

  public listPagedContractClient(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchContractClient(
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listContractClient(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getContractClientbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedContractClient(
    page: number,
    rows = 15,
    model: SearchContractClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  // public downloadContractClient(id: number): Observable<ResponseRequestModel> {
  //   return this.httpClient.get<ResponseRequestModel>(
  //     `${this.baseUrl}${this.resource}/download-excel?id=${id}`,
  //   )
  // }

  public listPagedFileContractClient(
    page: number,
    rows = 15,
    id: string,
  ): Observable<ResponseRequestModel> {
    const model = { contratoId: id }
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/arquivo/contrato-id?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public uploadFileContractClient(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/upload`,
      model,
    )
  }

  public deleteFileContractClient(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/arquivo/${id}`,
    )
  }

  public downloadFileContractClient(
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/download/arquivo/${id}`,
    )
  }

  public editContractAssociateConsultantOperate(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit/consultor-operacional`,
      model,
    )
  }

  public getOrcamentoPdfData(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/dados-pdf-orcamento/${id}`,
    )
  }

  public getLogisticaPdf(id: number): Observable<HttpResponse<Blob>> {
    return this.httpClient.get(
      `${this.baseUrl}${this.resource}/dados-pdf-logistica/${id}`,
      { responseType: 'blob', observe: 'response' },
    )
  }

  public sendEmailCliente(model: SendEmailContratoClienteModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/send-email-cliente`,
      model,
    )
  }

  public sendEmailLogistica(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/send-email-logistica/${id}`,
      null,
    )
  }
}
